import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { loginRequest } from "./authConfig";

import { UserProvider } from './contexts/UserContext';
import { ThemeProvider } from './contexts/ThemeContext';
import AuthHandler from './components/AuthHandler';
import { Layout } from './components/Layout';

import LoginPage from './pages/LoginPage';
import DetailPage from './pages/DetailPage';
import TicketSummaryPage from './pages/TicketSummaryPage';
import PushedPage from './pages/PushedPage';
import DeletedPage from './pages/DeletedPage';
import { UsersAdminPage } from './pages/UsersAdminPage';
import { MappingsAdminPage } from './pages/MappingsAdminPage';
import HomePage from './pages/HomePage';
import ScansPage from './pages/ScansPage';
import CoverSheetPage from './components/Spreadsheet';
import BathchPage from './pages/BatchPage';
import PendingPage from './pages/PendingPage';
import AdminToolsPage from './pages/AdminToolsPage';
import RolesAdminPage from './pages/RolesAdminPage';
import EditReportPage from './pages/EditReportPage';
import BatchPage from './pages/BatchPage';
import BatchPageV2 from './pages/BatchPageV2';
import InventoryItemsAdminPage from './pages/InventoryItemsAdminPage';
import BatchStatusPage from './pages/BatchStatusPage';
function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          {/* --- PUBLIC ROUTES --- */}
          {/* Accessible without MSAL login */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/scans/:branch/:warehouse" element={<ScansPage />} />
          <Route path="/batch-status/:batchId" element={<BatchStatusPage />} />
          {/* <Route path="/coversheet/:branch/:warehouse" element={<CoverSheetPage />} /> */}

          {/* --- PROTECTED ROUTES --- */}
          {/* Logic inlined directly into the parent Route element */}
          <Route
            element={
              <MsalAuthenticationTemplate
                interactionType={InteractionType.Redirect}
                authenticationRequest={loginRequest}
              >
                <UserProvider>
                  <AuthHandler>
                    {/* Ensure your <Layout> component contains an <Outlet /> */}
                    <Layout /> 
                  </AuthHandler>
                </UserProvider>
              </MsalAuthenticationTemplate>
            }
          >
            {/* These define what renders inside the Layout's <Outlet /> */}
            <Route path="/" element={<HomePage />} />
            <Route path="/pending" element={<PendingPage />} />
            <Route path="/pushed" element={<PushedPage />} />
            <Route path="/deleted" element={<DeletedPage />} />
            <Route path="/ticket/:id" element={<DetailPage />} />
            <Route path="/admin/users" element={<UsersAdminPage />} />
            <Route path="/admin/mappings" element={<MappingsAdminPage />} />
            <Route path="/admin/tools" element={<AdminToolsPage />} />
            <Route path="/admin/roles" element={<RolesAdminPage />} />
            <Route path="/admin/edit-report" element={<EditReportPage />} />
            <Route path="/admin/inventory" element={<InventoryItemsAdminPage />} />
            <Route path="/batch" element={<BatchPage />} />
            <Route path="/batch-v2" element={<BatchPageV2 />} />
          </Route>

          {/* Fallback */}
          <Route path="*" element={<div>Page Not Found</div>} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
